import React from 'react';
import { bool, func, object } from 'prop-types';
import CompensationSummaryCard from '../CompensationSummaryCard/CompensationSummaryCard';
import SurveyJob from './SurveyJob/SurveyJob';
import { getColumnIndex } from 'ps-components/AdvancedTable/GenericGrid/GenericGridHelper';

class SurveyJobDescription extends React.Component {
  static propTypes = {
    checked: bool,
    data: object,
    onToggle: func,
    isConfigVisible: bool
  };

  getJobRows() {
    const { data } = this.props;
    const jobDescriptionIndex = getColumnIndex(data, 'job_description_default');
    const surveyCodeIndex = getColumnIndex(data, 'survey_code_default');
    const surveyJobCodeIndex = getColumnIndex(data, 'job_code_default');
    const surveyJobTitleIndex = getColumnIndex(data, 'job_title_default');

    return data.data.map((job, index) => {
      return (
        <SurveyJob
          key={`survey-jd-${index}`}
          surveyJobCode={job[surveyJobCodeIndex]}
          surveyJobTitle={job[surveyJobTitleIndex]}
          surveyCode={job[surveyCodeIndex]}
          surveyJobDescription={
            jobDescriptionIndex !== -1 && job[jobDescriptionIndex]
              ? job[jobDescriptionIndex]
              : 'There is no description for this survey job.'
          }
        />
      );
    });
  }

  render() {
    const { checked, onToggle, isConfigVisible, data } = this.props;
    const hasData = data.data.length > 0;

    return (
      <CompensationSummaryCard
        cardTitle="Survey Job Description"
        checked={checked}
        hasData={hasData}
        onToggle={onToggle}
        isConfigVisible={isConfigVisible}
      >
        {this.getJobRows()}
      </CompensationSummaryCard>
    );
  }
}

export default SurveyJobDescription;
